import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Card = createSvgIcon(
  () => (
    <path d="M0 25C0 26.6875 1.3125 28 3 28H33C34.625 28 36 26.6875 36 25V14H0V25ZM12 20.75C12 20.375 12.3125 20 12.75 20H21.25C21.625 20 22 20.375 22 20.75V23.25C22 23.6875 21.625 24 21.25 24H12.75C12.3125 24 12 23.6875 12 23.25V20.75ZM4 20.75C4 20.375 4.3125 20 4.75 20H9.25C9.625 20 10 20.375 10 20.75V23.25C10 23.6875 9.625 24 9.25 24H4.75C4.3125 24 4 23.6875 4 23.25V20.75ZM36 3C36 1.375 34.625 0 33 0H3C1.3125 0 0 1.375 0 3V6H36V3Z" />
  ),
  '0 0 36 32'
);
